{
  "ai.answers.label": "Answers",
  "ai.answers.minimized": "Minimized",
  "ai.answers.note": "Page shows the conversation in the home's main column. Sidebar keeps it beside you.",
  "ai.answers.page": "Page",
  "ai.answers.sidebar": "Sidebar",
  "ai.assistantMode.apps": "Apps",
  "ai.assistantMode.assistant": "Assistant",
  "ai.assistantMode.dashboard": "Dashboard",
  "ai.assistantMode.desc.apps": "Builds a small app",
  "ai.assistantMode.desc.assistant": "Answers with text and live blocks",
  "ai.assistantMode.desc.dashboard": "Builds a board of widgets",
  "ai.assistantMode.desc.fly": "Composes a page for every ask",
  "ai.assistantMode.desc.presentation": "Makes a live deck",
  "ai.assistantMode.desc.tools": "Works inside your apps",
  "ai.assistantMode.fly": "Fly",
  "ai.assistantMode.label": "Mode",
  "ai.assistantMode.labelWithContext": "Mode: {mode} · Context: {context}",
  "ai.assistantMode.menuWithContext": "Context and mode",
  "ai.assistantMode.presentation": "Presentation",
  "ai.assistantMode.tools": "Tools",
  "ai.bridge.done": "Done",
  "ai.bridge.step1": "Start your local Simone bridge (Claude Code) on this machine.",
  "ai.bridge.step3": "Once it reports Connected above, your chats run on your local agent.",
  "ai.bridge.title": "Connect your local AI",
  "ai.bridge.urlLabel": "Bridge URL",
  "ai.chat.addComponentError": "Error adding component: {error}",
  "ai.chat.assistant": "Symbols AI",
  "ai.chat.cannotProcess": "Sorry, I could not process that request.",
  "ai.chat.clear": "Clear",
  "ai.chat.codeLine": "{count} line",
  "ai.chat.codeLines": "{count} lines",
  "ai.chat.actionDone": "· {count} action completed",
  "ai.chat.actionsDone": "· {count} actions completed",
  "ai.chat.hint": "Ask anything about Symbols",
  "ai.chat.hintWorkspace": "Ask anything about {workspace}",
  "ai.chat.history": "Chat history",
  "ai.chat.historyHeading": "History",
  "ai.chat.invalidCode": "Invalid code response format.",
  "ai.chat.messagesLabel": "Conversation",
  "ai.chat.newChat": "New chat",
  "ai.chat.noPrevious": "No previous chats.",
  "ai.chat.noResponse": "Received no response from the assistant.",
  "ai.chat.placeholder": "Describe a change or ask a question…",
  "ai.chat.placeholderInspector": "Describe a change, ask a question, or reference $0 from the inspector…",
  "ai.chat.renderError": "Error rendering component: {error}",
  "ai.chat.sendMessage": "Send message",
  "ai.chat.starter.help": "What can you help me with?",
  "ai.chat.starter.symbols": "What is Symbols?",
  "ai.chat.startersLabel": "Try asking",
  "ai.chat.subGenerating": "Looking at what {workspace} is working on…",
  "ai.chat.needsOk": "Needs your OK",
  "ai.chat.switchModel": "✦ Switch model",
  "ai.chat.system": "System",
  "ai.chat.thinking": "Thinking",
  "ai.chat.tool": "Tool",
  "ai.chat.unreachable": "Failed to reach Simone: {error}",
  "ai.chat.uploadImage": "Upload image",
  "ai.chat.voiceTooltip": "Voice — click to toggle, hold to talk",
  "ai.chat.working": "Working",
  "ai.chat.you": "You",
  "ai.chatCard.agentRole": "AI agent",
  "ai.chatCard.applyChange": "Apply this change?",
  "ai.chatCard.approve": "Approve",
  "ai.chatCard.cancel": "Cancel",
  "ai.chatCard.confirm": "Confirm",
  "ai.chatCard.handled": "✓ Handled",
  "ai.chatCard.memberFallback": "Member",
  "ai.chatCard.notApplied": "✗ Not applied",
  "ai.chatCard.rejected": "Rejected",
  "ai.chatCard.ticketFallback": "Task",
  "ai.chatCard.ask.change": "Change",
  "ai.chatCard.ask.changeMessage": "Change my answer for “{question}” to: {answer}",
  "ai.chatCard.ask.changeMessageShort": "Change my answer: {answer}",
  "ai.chatCard.ask.closedEnd": "Not answered — the conversation stopped before your answer",
  "ai.chatCard.ask.closedStop": "Not answered — you stopped the reply",
  "ai.chatCard.ask.editAnswer": "Asked for a change: {words}",
  "ai.chatCard.ask.editPlaceholder": "What should change?",
  "ai.chatCard.ask.keepAnswer": "Keep my answer",
  "ai.chatCard.ask.ownPlaceholder": "Your answer…",
  "ai.chatCard.ask.writeOwn": "Write my own",
  "ai.composer.placeholderAppsBuild": "Describe an app to build…",
  "ai.composer.placeholderAppsBuildShort": "Build an app…",
  "ai.composer.placeholderAppsBuildTiny": "Build…",
  "ai.composer.placeholderAssistant": "Ask anything…",
  "ai.composer.placeholderAssistantShort": "Ask anything…",
  "ai.composer.placeholderAssistantTiny": "Ask…",
  "ai.composer.placeholderDashboard": "Describe a dashboard…",
  "ai.composer.placeholderDashboardCall": "Ask for a dashboard — everyone in the call sees it…",
  "ai.composer.placeholderDashboardShort": "New dashboard…",
  "ai.composer.placeholderDashboardCallShort": "A dashboard for the call…",
  "ai.composer.placeholderDashboardTiny": "Dashboard…",
  "ai.composer.placeholderFly": "Ask anything — get a page…",
  "ai.composer.placeholderFlyCall": "Ask for a page — everyone in the call sees it…",
  "ai.composer.placeholderFlyCallShort": "Ask for the call…",
  "ai.composer.placeholderFlyShort": "Ask for a page…",
  "ai.composer.placeholderFlyTiny": "Ask…",
  "ai.composer.placeholderPresentation": "Describe a presentation…",
  "ai.composer.placeholderPresentationCall": "Ask for slides — everyone in the call sees them…",
  "ai.composer.placeholderPresentationShort": "New presentation…",
  "ai.composer.placeholderPresentationCallShort": "Slides for the call…",
  "ai.composer.placeholderPresentationTiny": "Slides…",
  "ai.composer.placeholderTools": "Work in your apps…",
  "ai.composer.placeholderToolsShort": "Use your apps…",
  "ai.composer.placeholderToolsTiny": "Apps…",
  "ai.confidence.band.high": "High",
  "ai.confidence.band.insufficient": "Insufficient",
  "ai.confidence.band.low": "Low",
  "ai.confidence.band.moderate": "Moderate",
  "ai.confidence.capsTitle": "Limits applied",
  "ai.confidence.factor.authority": "Authority",
  "ai.confidence.factor.consistency": "Consistency",
  "ai.confidence.factor.coverage": "Coverage",
  "ai.confidence.factor.freshness": "Freshness",
  "ai.confidence.factor.precedent": "Precedent",
  "ai.confidence.factor.self": "Self-reported",
  "ai.confidence.noScore": "This answer carries no confidence score.",
  "ai.confidence.toggle": "Show how this score was computed",
  "ai.confidence.unscored": "Unscored",
  "ai.confirm.kind.docCreate": "Create document",
  "ai.confirm.kind.eventCreate": "Create event",
  "ai.confirm.kind.kbCreate": "Create KB article",
  "ai.confirm.kind.noteCreate": "Create note",
  "ai.confirm.kind.ticketCreate": "Create task",
  "ai.confirm.kind.ticketMove": "Move task",
  "ai.confirm.kind.ticketUpdate": "Update task",
  "ai.confirm.reject": "Reject",
  "ai.confirm.title": "AI proposes these actions",
  "ai.contextBar.chip.mutedTitle": "{name} — excluded from the prompt; click to include",
  "ai.contextBar.chip.refTitle": "{name} — the AI's reference; click to ask about something else",
  "ai.contextBar.chip.remove": "Remove {name}",
  "ai.contextBar.scopeLine": "AI can reach: {scope}",
  "ai.contextBar.tag.dropped": "not sent",
  "ai.contextBar.tag.textOnly": "as text",
  "ai.contextBar.tag.truncated": "partial",
  "ai.level.band.commercialDecision": "Commercial decision",
  "ai.level.band.commercialNote": "Commercial note",
  "ai.level.band.commercialRecommendation": "Commercial recommendation",
  "ai.level.band.legalDecision": "Legal decision",
  "ai.level.band.legalNote": "Legal note",
  "ai.level.band.legalRecommendation": "Legal recommendation",
  "ai.level.ceilingsTitle": "Ceilings that applied",
  "ai.level.emitted": "Emitted level",
  "ai.level.outOfScope": "Out of scope",
  "ai.level.requested": "Requested level",
  "ai.level.retreat": "Retreat",
  "ai.level.toggle": "Show how this level was set",
  "ai.menu.playground": "AI Playground",
  "ai.menu.title": "AI Tools:",
  "ai.mode.permAsk.label": "Ask permissions",
  "ai.mode.permAsk.sub": "Confirm SDK actions before they fire",
  "ai.mode.permAuto.label": "Auto",
  "ai.mode.permAuto.sub": "AI executes actions immediately",
  "ai.mode.providerCloud.label": "Symbols Cloud",
  "ai.mode.providerCloud.sub": "Managed keys, zero setup",
  "ai.mode.providerLocal.label": "Local agent",
  "ai.mode.providerLocal.sub": "Requires simone-bridge",
  "ai.mode.providerOrg.label": "Org providers",
  "ai.mode.providerOrg.sub": "Your org's keys (Vault)",
  "ai.model.anthropic.sub": "Claude models",
  "ai.model.auto": "Auto",
  "ai.model.auto.sub": "Best model per task",
  "ai.model.cheap": "Cheap",
  "ai.model.cheap.sub": "Lowest-cost models",
  "ai.model.gemini.sub": "Google models",
  "ai.model.openai.sub": "GPT models",
  "ai.model.openrouter.sub": "Routed providers",
  "ai.model.research": "Research",
  "ai.model.research.sub": "Deep research mode",
  "ai.model.simone.sub": "Symbols-managed assistant",
  "ai.modelSwitcher.ariaLabel": "AI model and provider",
  "ai.modelSwitcher.model": "Model",
  "ai.modelSwitcher.provider": "Provider",
  "ai.modelSwitcher.someOff": "{count} more are off on this server",
  "ai.panel.actions": "Actions",
  "ai.panel.fieldHint": "Up arrow opens the context and suggestions",
  "ai.panel.label": "Assistant context and suggestions",
  "ai.panel.suggestions": "Suggestions",
  "ai.pill.agentWorking": "{count} agent working",
  "ai.pill.agentsWorking": "{count} agents working",
  "ai.pill.answerReady": "Answer ready",
  "ai.pill.dismiss": "Dismiss",
  "ai.pill.dismissLabel": "Dismiss the assistant pill",
  "ai.pill.idle": "Assistant",
  "ai.pill.open": "Open the assistant",
  "ai.pill.openInMain": "Open in main",
  "ai.pill.openInSidebar": "Open in sidebar",
  "ai.policy.status.active": "Active",
  "ai.policy.status.cancelled": "Cancelled",
  "ai.policy.status.declined": "Declined",
  "ai.policy.status.due": "Payment due",
  "ai.policy.status.expired": "Expired",
  "ai.policy.status.expiring": "Expiring soon",
  "ai.policy.status.lapsed": "Lapsed",
  "ai.policy.status.pastDue": "Past due",
  "ai.policy.status.pending": "Pending",
  "ai.policy.status.pendingRenewal": "Pending renewal",
  "ai.policy.status.renewed": "Renewed",
  "ai.policy.status.unknown": "Unknown",
  "ai.scope.kind.app": "App",
  "ai.scope.kind.page": "Page",
  "ai.scope.kind.record": "Open item",
  "ai.scope.kind.workspace": "Workspace",
  "ai.scope.label": "Context",
  "ai.sessions.delete": "Delete session",
  "ai.sessions.empty": "No sessions yet.",
  "ai.sessions.new": "+ New",
  "ai.sessions.title": "Sessions",
  "ai.settings.appliesTo": "Applies to",
  "ai.settings.authAsk.label": "Ask first",
  "ai.settings.authAsk.sub": "Confirm actions before they run",
  "ai.settings.authAuto.label": "Auto",
  "ai.settings.authAuto.sub": "Run actions immediately",
  "ai.settings.authorization": "Authorization",
  "ai.settings.localAgent": "Local agent",
  "ai.settings.localAgentSub": "Your machine via simone-bridge",
  "ai.settings.localAgentSubActive": "Your machine via simone-bridge — tap to switch back",
  "ai.settings.panelLabel": "AI settings",
  "ai.settings.pin.activeSuffix": "{model} — every member's turns use it",
  "ai.settings.pin.off": "Off — each member picks their own model",
  "ai.settings.pin.saveFailed": "Couldn't save the workspace setting",
  "ai.settings.pinModel": "Pin a model",
  "ai.settings.pinNone.label": "No pin",
  "ai.settings.pinNone.sub": "Each member picks their own model",
  "ai.settings.pinnedModel": "Pinned model",
  "ai.settings.provider": "AI provider",
  "ai.settings.reliability.empty": "No AI tool turns recorded yet",
  "ai.settings.reliability.label": "Tool turns: {pct}% ok ({ok} of {total}, {days} days)",
  "ai.settings.reliability.leak": "{count} text leak",
  "ai.settings.reliability.leaks": "{count} text leaks",
  "ai.settings.reliability.noLeaks": "No text leaks in this window",
  "ai.settings.reliability.window": "Last {days} days",
  "ai.settings.reliabilityGroup": "AI reliability",
  "ai.settings.scope.me": "Just me",
  "ai.settings.scope.workspace": "Workspace",
  "ai.settings.scopeAdminOnly": "Requires an admin or owner workspace role",
  "ai.settings.scopeNote.me": "Changes here apply only to your own chats.",
  "ai.settings.scopeNote.workspace": "Sets assistant authorization and the pinned model for everyone in this workspace.",
  "ai.settings.switchModel": "Switch AI model",
  "ai.settings.voiceGroup": "Voice",
  "ai.settings.voiceOff.label": "Text only",
  "ai.settings.voiceOff.sub": "Never speak replies",
  "ai.settings.voiceOn.label": "Speak replies",
  "ai.settings.voiceOn.sub": "Simone reads answers aloud",
  "ai.settings.workspaceModel": "Workspace model",
  "ai.sources.kind.canvas": "Canvas",
  "ai.sources.kind.channel": "Channel",
  "ai.sources.kind.doc": "Document",
  "ai.sources.kind.event": "Event",
  "ai.sources.kind.file": "File",
  "ai.sources.kind.mail": "Thread",
  "ai.sources.kind.record": "Record",
  "ai.sources.kind.ticket": "Task",
  "ai.sources.kind.unknown": "Item",
  "ai.sources.open": "Open {name}",
  "ai.sources.unreadable": "not readable in this workspace",
  "ai.sources.unreadableTitle": "{name} — not readable in this workspace",
  "ai.sources.unverified": "unverified",
  "ai.tool.input": "Details",
  "ai.tool.items": "{count} items",
  "ai.tool.output": "output",
  "ai.tool.result": "Result",
  "ai.tool.run": "Run",
  "ai.tool.runAll": "Run all",
  "ai.tool.runAllTooltip": "Run this and every remaining action in this run — this turn only",
  "ai.tool.skip": "Skip",
  "ai.tool.skipped": "skipped",
  "ai.tool.undo": "Undo",
  "ai.tool.undone": "undone",
  "ai.tool.undoWhy.gone": "It could not be found here.",
  "ai.tool.undoWhy.denied": "You do not have permission to delete it.",
  "ai.tool.undoWhy.unavailable": "This page cannot undo it.",
  "ai.tool.undoWhy.network": "Could not reach the server. Check your connection.",
  "ai.tool.undoWhy.failed": "An unexpected error occurred.",
  "ai.toolStep.search": "Searching the workspace",
  "ai.toolStep.searchFor": "Searching “{query}”",
  "ai.toolStep.navigate": "Navigating",
  "ai.toolStep.openRoute": "Opening {route}",
  "ai.toolStep.openBeside": "Opening {route} beside the chat",
  "ai.toolStep.closeSplit": "Closing the split pane",
  "ai.toolStep.drawAnswer": "Drawing an answer view",
  "ai.toolStep.drawAnswerNamed": "Drawing “{title}”",
  "ai.toolStep.openItem": "Opening an item",
  "ai.toolStep.openType": "Opening the {type}",
  "ai.toolStep.switchTheme": "Switching theme",
  "ai.toolStep.switchThemeTo": "Switching to {theme} theme",
  "ai.toolStep.confirm": "Waiting for your confirmation",
  "ai.toolStep.choose": "Waiting for your choice",
  "ai.toolStep.chose": "You chose “{choice}”",
  "ai.toolStep.answered": "You answered",
  "ai.toolStep.askUnanswered": "Unanswered question",
  "ai.toolStep.closeDialogs": "Closing dialogs",
  "ai.toolStep.showCards": "Showing cards",
  "ai.toolStep.readProjects": "Reading projects",
  "ai.toolStep.readRecords": "Reading “{collection}” records",
  "ai.toolStep.listCollections": "Listing record collections",
  "ai.toolStep.checkDeployments": "Checking deployments",
  "ai.toolStep.readBuildLog": "Reading a build log",
  "ai.toolStep.readBuilds": "Reading builds",
  "ai.toolStep.readEnvironments": "Reading environments",
  "ai.toolStep.readProject": "Reading a project",
  "ai.toolStep.createProject": "Creating a project",
  "ai.toolStep.createProjectNamed": "Creating project “{name}”",
  "ai.toolStep.updateProject": "Updating a project",
  "ai.toolStep.commitChanges": "Writing project changes",
  "ai.toolStep.buildExtension": "Building the app",
  "ai.toolStep.buildExtensionNamed": "Building “{name}”",
  "ai.toolStep.createApp": "Building an app",
  "ai.toolStep.updateApp": "Updating the app",
  "ai.toolStep.readMembers": "Reading members",
  "ai.toolStep.inviteMember": "Inviting a member",
  "ai.toolStep.inviteEmail": "Inviting {email}",
  "ai.toolStep.readInvitations": "Reading invitations",
  "ai.toolStep.cancelInvitation": "Cancelling an invitation",
  "ai.toolStep.updateRole": "Updating a member role",
  "ai.toolStep.removeMember": "Removing a member",
  "ai.toolStep.renameWorkspace": "Renaming the workspace",
  "ai.toolStep.readAgents": "Reading agents",
  "ai.toolStep.createAgent": "Creating an agent",
  "ai.toolStep.createAgentNamed": "Creating agent “{name}”",
  "ai.toolStep.updateAgent": "Updating an agent",
  "ai.toolStep.delegate": "Delegating to agents",
  "ai.toolStep.chainAgents": "Running an agent chain",
  "ai.toolStep.createTicket": "Creating a task",
  "ai.toolStep.createTicketNamed": "Creating the task “{title}”",
  "ai.toolStep.updateTicket": "Updating a task",
  "ai.toolStep.assignTo": "Assigning to {email}",
  "ai.toolStep.clearAssignee": "Clearing the assignee",
  "ai.toolStep.moveTicket": "Moving a task",
  "ai.toolStep.deleteTicket": "Deleting a task",
  "ai.toolStep.propose": "Proposing an action for approval",
  "ai.toolStep.proposeSummary": "Proposing for approval: {summary}",
  "ai.toolStep.createFolder": "Creating a folder",
  "ai.toolStep.createNote": "Creating a note",
  "ai.toolStep.createNoteNamed": "Creating note “{title}”",
  "ai.toolStep.createChannel": "Creating a channel",
  "ai.toolStep.sendMessage": "Sending a message",
  "ai.toolStep.readDrawing": "Reading the canvas",
  "ai.toolStep.addDrawing": "Drawing on the canvas",
  "ai.toolStep.editDrawing": "Editing the drawing",
  "ai.toolStep.eraseDrawing": "Erasing from the canvas",
  "ai.toolStep.clearDrawing": "Clearing the canvas",
  "ai.toolStep.created": "Created a {kind}",
  "ai.toolStep.createdNamed": "Created {kind} “{title}”",
  "ai.toolStep.generic": "Running a step",
  "ai.toolStep.oneItem": "1 item",
  "ai.toolKind.note": "note",
  "ai.toolKind.document": "document",
  "ai.toolKind.ticket": "task",
  "ai.toolKind.channel": "channel",
  "ai.toolKind.folder": "folder",
  "ai.toolKind.project": "project",
  "ai.toolKind.agent": "agent",
  "ai.toolKind.event": "event",
  "ai.toolKind.item": "item",
  "ai.toolArg.task": "Task",
  "ai.toolArg.title": "Title",
  "ai.toolArg.name": "Name",
  "ai.toolArg.description": "Description",
  "ai.toolArg.text": "Text",
  "ai.toolArg.message": "Message",
  "ai.toolArg.status": "Status",
  "ai.toolArg.priority": "Priority",
  "ai.toolArg.assignee": "Assignee",
  "ai.toolArg.dueDate": "Due date",
  "ai.toolArg.type": "Type",
  "ai.toolArg.column": "Column",
  "ai.toolArg.event": "Event",
  "ai.toolArg.date": "Date",
  "ai.toolArg.start": "Starts",
  "ai.toolArg.end": "Ends",
  "ai.toolArg.timeZone": "Time zone",
  "ai.toolArg.invitees": "Invitees",
  "ai.toolArg.project": "Project",
  "ai.toolArg.page": "Page",
  "ai.toolArg.note": "Note",
  "ai.toolArg.folder": "Folder",
  "ai.toolArg.file": "File",
  "ai.toolArg.channel": "Channel",
  "ai.toolArg.email": "Email",
  "ai.toolArg.role": "Role",
  "ai.toolArg.search": "Search",
  "ai.toolArg.newName": "New name",
  "ai.toolArg.newTitle": "New title",
  "ai.toolArg.agent": "Agent",
  "ai.toolArg.theme": "Theme",
  "ai.toolArg.summary": "Summary",
  "ai.tool.superseded": "Skipped — you sent a new message",
  "ai.tool.runNow": "Run it now",
  "ai.tool.undoFailed": "Undo did not work.",
  "ai.tool.undoRetry": "Try again",
  "ai.tool.widgetHint": "This widget will be added to your home board",
  "ai.voice.askNotice": "Needs your OK: {step}. Choose Run or Skip on the screen.",
  "ai.voice.askNoticeBare": "A step needs your OK. Choose Run or Skip on the screen.",
  "ai.voice.choiceNotice": "{prompt} Choose your answer on the screen.",
  "ai.voice.choiceNoticeBare": "A question waits for your answer. Choose it on the screen."
}
